
namespace Matrix.Indexation {
    export class DimIndexesColumns {
        static columnsKey = 'Indexation.DimIndexes';
    }
}